import { useState, useEffect } from 'react';
import { CONTRACT_ADDRESSES } from '@/config/contracts';

interface MintedQuantities {
  base: number;
  pulsechain: number;
  chia: number;
}

export function useMintedQuantities() {
  const [quantities, setQuantities] = useState<MintedQuantities>({
    base: 0,
    pulsechain: 0,
    chia: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Hardcoded values for now
  useEffect(() => {
    setQuantities({
      base: 0,
      pulsechain: 0,
      chia: 0
    });
  }, []);

  return { quantities, loading, error };
} 